export default __webpack_public_path__ + "static/media/block_blanc-eval.5c5c4d74.png";